module.exports = __webpack_public_path__ + "static/media/title-bg-how-to-work2.4357e8ef.png";